<template>
  <Dialog
    v-model:show="visible"
    :title="title || '确认操作'"
    width="min(400px, 92vw)"
    teleport="body"
    show-cancel-button
    :confirm-button-text="confirmText || '确认'"
    :cancel-button-text="cancelText || '取消'"
    confirm-button-color="#dc2626"
    :close-on-click-overlay="false"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <div class="confirm-content px-6 py-5">
      <p>{{ message }}</p>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { Dialog } from 'vant';

  interface Props {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
  }

  withDefaults(defineProps<Props>(), {
    title: '确认操作',
    confirmText: '确认',
    cancelText: '取消',
  });

  const visible = ref(false);
  const resolvePromise = ref<((value: boolean) => void) | null>(null);

  const show = (): Promise<boolean> => {
    visible.value = true;
    return new Promise((resolve) => {
      resolvePromise.value = resolve;
    });
  };

  const handleConfirm = () => {
    visible.value = false;
    resolvePromise.value?.(true);
    resolvePromise.value = null;
  };

  const handleCancel = () => {
    visible.value = false;
    resolvePromise.value?.(false);
    resolvePromise.value = null;
  };

  defineExpose({
    show,
  });
</script>

<style scoped>
  .confirm-content {
    overflow: visible !important;
    height: auto !important;
    line-height: 1.6;
  }

  .confirm-content p {
    margin: 0;
    white-space: pre-line;
    word-wrap: break-word;
    color: #666;
    font-size: 14px;
    line-height: 1.6;
  }
</style>
